import { FieldArray, useFormikContext } from 'formik';
import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SectionHeader from '../../../../components/SectionHeader';
import LocationWorkingHoursItem from './LocationWorkingHoursItem';
import Button from '../../../../components/buttons/Button';

export default function LocationWorkingHours() {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(0);
  const formik = useFormikContext<any>();

  return (
    <div className={'model_gallery model_exterior_images'}>
      <SectionHeader title={t('working_hours')}>
        <div style={{ paddingBottom: '2rem' }}>
          <div className="accordions-container">
            <FieldArray
              name="working_hours"
              render={(arrayHelpers) => (
                <Fragment>
                  {(formik?.values?.working_hours || [])?.map((item: any, index: number) => {
                    return <LocationWorkingHoursItem data={item} expanded={expanded} setExpanded={setExpanded} index={index} arrayHelpers={arrayHelpers} />;
                  })}
                  {formik?.values?.working_hours?.length === 0 && (
                    <div className="no_data">
                      <h6>{t('no_working_hours')}</h6>
                    </div>
                  )}
                  <div className="form_button reverse">
                    <Button type="button" onClick={() => arrayHelpers.push({})}>
                      <span className="bold">{t('add_item')}</span>
                    </Button>
                  </div>
                </Fragment>
              )}
            />
          </div>
        </div>
      </SectionHeader>
    </div>
  );
}
